var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomElectricitySwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M0 0h15v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    "data-svg-class": "RoomButton-stroke",
    d: "M.5.5h14v24H.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 7.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    "data-svg-class": "RoomButton-stroke",
    cx: 7.5,
    cy: 5.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 7.5,
    cy: 19.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    "data-svg-class": "RoomButton-stroke",
    cx: 7.5,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M6 11h3v5H6z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    "data-svg-class": "RoomButton-stroke",
    d: "M6.5 11.5h2v4h-2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M6 9h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    "data-svg-class": "RoomButton-stroke",
    d: "M6.5 9.5h2v2h-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricitySwitch);
export default __webpack_public_path__ + "static/media/RoomElectricitySwitch.d55f73245f6edd836f7a9f3c7283eb92.svg";
export { ForwardRef as ReactComponent };